import { CameraSvgIcon } from './svg';
import { makeIcon } from './make-icon';

export const CameraIcon = makeIcon(CameraSvgIcon, 'CameraIcon')`
  position: relative;
  top: 0.1em;
  path {
    fill: currentColor;
  }
`;
